const agGridCommunity = require('../../node_modules/ag-grid-community/dist/package/main.cjs.js')

// Explicit exports allow webpack 4 static analysis to find named imports.
// Object.assign adds all remaining exports at runtime for ag-grid-react internals (e.g. BeanStub).
const shim = {
    AllCommunityModule: agGridCommunity.AllCommunityModule,
    ModuleRegistry: agGridCommunity.ModuleRegistry,
}
Object.assign(shim, agGridCommunity)
module.exports = shim